<template>
  <div class="map-subcat-row">
    <div class='subcat-spacer'
      @click="toggleIndicators"></div>
    <transition name="collapse">
      <div class='indicator-wrapper cursor-scroll-all' 
        v-show="subcategory.showCurrentIndicators"
        :aria-hidden="!subcategory.showCurrentIndicators">
        <year-column v-for="yearData in riskData" :key="yearData.year"
          :yearData="yearData"
          :catIndex="catIndex"
          :subcatIndex="subcatIndex"
          :subcategory="subcategory"
        ></year-column>
      </div>
    </transition>
  </div>
</template>

<script>
import YearColumn from './YearColumn';
import { toggleIndicators } from '../../helpers/openCloseHelpers';


export default {
  name: 'map-subcat-row',
  props: [
    'subcategory',
    'catIndex',
    'subcatIndex',
    'riskData',
  ],
  components: {
    'year-column': YearColumn,
  },
  methods: {
    toggleIndicators,
  },
};
</script>

<style lang="less">
  .indicator-wrapper {
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .map-subcat-row {
    margin-bottom: 2px;
  }
  .subcat-spacer {
    height: 20px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// MapSubcatRow.vue?417faece